import { render, staticRenderFns } from "./summaryTaskDialog.vue?vue&type=template&id=51bcadd2&scoped=true&"
import script from "./summaryTaskDialog.vue?vue&type=script&lang=js&"
export * from "./summaryTaskDialog.vue?vue&type=script&lang=js&"
import style0 from "./summaryTaskDialog.vue?vue&type=style&index=0&id=51bcadd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bcadd2",
  null
  
)

export default component.exports